import React, { FC, ReactNode } from 'react'
import { Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'

// 補助情報 (= 12/400/text.secondary). Notion §3.2 tag scale 相当.
// 主役 BodyText (14) より 1 段小さく、 主従関係を明示する.
// MetaLine / 量 / 用法 / 補足 / empty state / comment(※ は italic で) などに使用.
interface MetaTextProps {
  children: ReactNode
  sx?: SxProps<Theme>
}

export const MetaText: FC<MetaTextProps> = ({ children, sx }) => (
  // variant="caption" (= 12px) を経由して文字拡大 (large) に追従させる。
  // 見た目 (400 / 1.5 / text.secondary) は caption 既定と異なるため sx で踏襲。
  // caption 既定要素は span(inline) だが、 従来は p(block) で mt/mb/py が効いていたため
  // component="p" で block を維持する (各利用箇所の縦 margin を壊さない)。
  <Typography
    variant="caption"
    component="p"
    sx={[
      { fontWeight: 400, color: 'text.secondary', lineHeight: 1.5 },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Typography>
)
